import {Component, inject} from '@angular/core';
import {fetchAndActivate, getAll, RemoteConfig, Value} from "@angular/fire/remote-config";

import {Functions} from "@angular/fire/functions";
import {HttpClient} from "@angular/common/http";

@Component({
  selector: 'app-app-theme',
  standalone: true,
  imports: [],
  templateUrl: './app-theme.component.html',
  styleUrl: './app-theme.component.css'
})
export class AppThemeComponent {
  functions = inject(Functions);
  keys = ["app_link_app_store", "app_link_google_play"
    , "hard_version_requirement", "pre_scale_up", "SE_CREDITS"
    , "SE_DEACTIVATE_USER", "SE_DISCOUNTS", "SE_NETWORKS"
    , "welcome_screen_dialog_show", "welcome_screen_dialog_title"
    , "soft_version_requirement", "welcome_screen_dialog_body", "welcome_screen_dialog_button_text"
    , "welcome_screen_dialog_show", "welcome_screen_dialog_title"
  ]
  http = inject(HttpClient)
  configs: { key: string, value: Value }[] = [];
  private readonly remoteConfig: RemoteConfig = inject(RemoteConfig);

  constructor() {
    (async () => {
      await this.getValues();
    })()
  }

  async getValues() {
    await fetchAndActivate(this.remoteConfig);
    let rec = getAll(this.remoteConfig)
    this.configs = Object.entries(rec || {}).map(([key, value]) => ({key, value}));
  }

}
